import {
	Component,
	OnInit,
	ComponentRef
} from "@angular/core";

import { Resource } from "@impulse/sdp-shared-models";

import { ApiGatewayService } from "../../common/api-gateway/api-gateway.service";
import { ApplicationView } from "../../models";
import { BrowserTitleService } from "../../common/browser-title/browser-title.service";
import { TranslateService } from "../../common/translate/translate.service";
import { SnackbarService } from "../../common/snackbar/snackbar.service";
import { GenericTable } from "../../genericTable";
import { ApplicationImageComponent } from "../../common/application-image/application-image.component";
import { getResourceViewWithAccessList } from "../resource-view";

@Component({
	selector: "sdp-summary",
	templateUrl: "./summary.component.html"
})
export class SummaryComponent implements OnInit {
	public isDataLoaded = false;
	public data: Resource[] | undefined = undefined;

	public columnSchema: GenericTable.ColumnSchema[] = [
		{
			minWidth: "20%",
			type: "customComponent",
			headerSchema: {
				type: "basic",
				sortable: false,
				headerText: "applications.label.application"
			},
			bodySchema: {
				type: "customComponent",
				customComponent: ApplicationImageComponent,
				callback: customImageInit
			}
		}, {
			minWidth: "20%",
			type: "string",
			headerSchema: {
				type: "basic",
				sortable: true,
				headerText: "applications.label.name"
			},
			bodySchema: {
				type: "string",
				boundField: "name"
			}
		}, {
			minWidth: "60%",
			type: "tag",
			headerSchema: {
				type: "basic",
				headerText: "assignApplications.grid.user-group",
				sortable: true
			},
			bodySchema: {
				type: "tag",
				boundField: "accessList"
			}
		}];

	constructor(
		private titleService: BrowserTitleService,
		private apiGatewayService: ApiGatewayService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) { }

	public async ngOnInit() {
		this.titleService.setTitle("summary.header.title");
		await this.refresh();
	}

	public getPrettyPrintedRoles(resource: ApplicationView) {
		return resource.roles.join("; ");
	}

	private async refresh() {
		try {
			this.isDataLoaded = false;
			const [policies, aliases] = await Promise.all([this.apiGatewayService.getAllApplications(), this.apiGatewayService.getAllSamlAliases()]);
			this.data = getResourceViewWithAccessList(policies, aliases).map((app) => {
				return Object.assign<ApplicationView.ApplicationViewPartial, Resource>(
					{
						imageOptions: {
							applicationImage: {
								name: app.name,
								imageBase64: app.image
							},
							size: "small"
						}
					},
					app
				);
			});
		} catch (e) {
			this.snackbarService.open(this.translateService.translate(e));
		} finally {
			this.isDataLoaded = true;
		}
	}

}

function customImageInit(component: ComponentRef<ApplicationImageComponent>, data: ApplicationView) {
	const aic = component.instance;
	aic.applicationImage = data.imageOptions.applicationImage;
	aic.size = data.imageOptions.size;
}
